export enum AdvanceOrderStatus {
  OPEN = "open",
  APPROVING = "approving",
  DISAPPROVED = "disapproved",
  WAITING_PAYMENT = "waiting_payment",
  PAID = "paid",
}
